<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div v-if="viewPage"
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
    id="page-login"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div
          slot="no-body"
          class="full-page-bg-color"
          v-bind:class="{ 'bg-white': !showLoginImage }"
        >
          <div class="vx-row no-gutter justify-center items-center">
            <!-- <div class="vx-col hidden lg:block lg:w-1/2" v-if="showLoginImage">
              <img
                v-if="setLoginImage"
                :src="img_cdn + setLoginImage"
                alt="login"
                class="mx-auto"
              />
             </div> -->
           
             <img  :src="themeMode === 'dark' ? require('@/assets/images/logo/kv_logo_light.png'): require('@/assets/images/logo/kv_logo_dark.png')" style="max-width:16.7rem"  class=" fill-current text-primary mx-auto self-center mt-2" />

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">
                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">Login</h4>
                  <p>Welcome back, please login to your account.</p>
                </div>

                <div v-on:keyup.enter="submitData">
                  <div class="mb-3">
                  <!-- <label class="vs-select--label">Email or Username</label> -->
                      <vs-input
                        v-validate="'required|min:3'"
                        data-vv-validate-on="blur"
                        name="email"
                        icon-no-border
                        icon="icon icon-user"
                        icon-pack="feather"
                        label-placeholder="Email or Username"
                        v-model="email"
                        :tabindex="1"
                        data-vv-as="This field is required. Enter an email or username"
                        class="w-full"
                      />
                      <!--                  <span class="text-danger text-sm">{{ errors.first('username') }}</span>-->

                      <span
                        v-if="email == ''"
                        v-show="errors.has($tc('email'))"
                        class="text-danger text-sm"
                        >This field is required. Enter an email or username</span
                  ></div>
              
                  <!-- <label class="vs-select--label">Password</label> -->
                  <div>
                  <vx-input-group class="bc">
                    <template slot="append">
                      <div
                        class="append-text cursor-pointer bg-white"
                        style="
                          color: #b0afb7;
                          border: 1px solid rgba(0, 0, 0, 0.2);
                          border-left: none;
                        "
                      >
                        <span @click="showPassword = !showPassword">
                          <feather-icon
                            v-if="showPassword"
                            icon="EyeIcon"
                            class="flex-inline mt-2"
                            svgClasses="h-5 w-5"
                          />
                          <feather-icon
                            v-else
                            icon="EyeOffIcon"
                            class="flex-inline mt-2"
                            svgClasses="h-5 w-5"
                          />
                        </span>
                      </div>
                    </template>

                    <vs-input
                      :tabindex="2"
                      ref="password"
                      v-model="password"
                      icon="icon icon-lock"
                      icon-pack="feather"
                      icon-no-border
                      data-vv-validate-on="blur"
                      v-validate="'required|min:6|max:30'"
                      v-bind:type="[showPassword ? 'text' : 'password']"
                      name="password"
                      label-placeholder="Password"
                      class="w-full no-right-border"
                    />
                  </vx-input-group>
                  <span class="text-danger text-sm">{{
                    errors.first("password")
                  }}</span>
                  </div>
                  <div
                    class="flex flex-wrap justify-between my-5 onfocus-check"
                  >
                    <input
                      type="checkbox"
                      v-model="checkbox_remember_me"
                      id="checkbox_focus"
                      class="checkbox_focus"
                      :tabindex="3"
                    />
                    <label for="checkbox_focus" class="ml-10"
                      >Remember Me</label
                    >
                    <!-- <vs-checkbox v-model="checkbox_remember_me" :tabindex="3" class="mb-3" id="test5"></vs-checkbox> -->
                    <router-link
                      to="forgot-password"
                      class="onfocus-forgot"
                      :tabindex="4"
                      >Forgot Password?</router-link
                    >
                  </div>
                  <router-link to="/register">
                    <vs-button
                      type="border"
                      class="onfocus-register"
                      :tabindex="5"
                      >Register</vs-button
                    >
                  </router-link>

                  <div
                    id="div-with-loading"
                    class="vs-con-loading__container float-right"
                    :tabindex="6"
                  >
                    <vs-button
                      class="float-right"
                      @click.native="submitData"
                      :disabled="!validateForm"
                      >Login</vs-button
                    >
                  </div>
                  <!--                  <vs-button  ref="loadableButton"-->
                  <!--                             id="button-with-loading"-->
                  <!--                             class="vs-con-loading__container float-right"-->
                  <!--                              @click="submitData"-->
                  <!--                              type="relief"-->
                  <!--                              :disabled="!validateForm">Login</vs-button>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>

    <vs-prompt
      class="security-warning-popup"
      color="primary"
      title="Security Warning!"
      @cancel="activePrompt2 = false"
      @accept="this.sendLoginRequest"
      @close="closeSecurityPopup"
      :active.sync="activePrompt2"
    >
      <div class="con-exemple-prompt">
        <p>We have found this user loggedin on another device.</p>
        <div class="text-center" v-if="prevDevice">
          <div class="flex items-center justify-center">
            <span class="material-icons" v-if="prevDevice.type === 'desktop'"
              >laptop</span
            >
            <span class="material-icons" v-else>phone_android</span>
            <p class="ml-2">
              {{ prevDevice.os }}
              {{ prevDevice.client | first_letter_uppercase }}
              {{ prevDevice.device }}
            </p>
          </div>
        </div>
        <br />
        <p>Do you want to logout of the other session?</p>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import {
  ADD_LOGIN_TIME,
  APP_TOKEN,
  CREATE_LOGIN_COUNTER,
  CHECK_CENTER_EXIST,
  LOGIN_MUTATION,
  ROLES_KEY,
  CHECK_USER_SESSION
} from '@/graphql'
import DeviceDetector from 'device-detector-js'
 
import 'firebase/auth'
export default {
  props: {
    tabindex: {
      type: Number,
      required: false,
      default: 1
    }
  },
  data () {
    return {
      email: '',
      password: '',
      loader: true,
      checkbox_remember_me: false,
      roles: [],
      img_cdn: process.env.VUE_APP_IMAGES_CDN_LINK,
      setLoginImage: '',
      showLoginImage: false,
      showPassword: false,
      activePrompt2: false,
      activePrompt: false,
      originalDevice: null,
      prevDevice: null,
      viewPage:false
    }
  },

  computed: {
    validateForm () {
      return !this.errors.any() && this.email !== '' && this.password !== ''
    },
    themeMode () {
      return this.$store.state.theme  
    }
  },
  methods: {
    closeSecurityPopup (value) {
      if (!value) this.activePrompt2 = true
    },
    openLoadingInDiv () {
      this.$vs.loading({
        container: '#div-with-loading',
        scale: 0.6
      })
    },
    openLoadingContained () {
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: '#button-with-loading',
        scale: 0.45
      })
    },
    LoginCounter (id) {
      this.$apollo
        .mutate({
          mutation: CREATE_LOGIN_COUNTER,
          variables: {
            user_id: id
          }
        })
        .then((response) => {
          if (response) {
            // window.location = '/'
          }
        })
        .catch((error) => {})
    },
    LastLogin (id) {
      this.$apollo
        .mutate({
          mutation: ADD_LOGIN_TIME,
          variables: {
            id
          }
        })
        .then((response) => {
          if (response) {
            // window.location = '/'
          }
        })
        .catch((error) => {})
    },
    setCheckBoxvalue () {
      this.checkbox_remember_me = !this.checkbox_remember_me
    },

    sendLoginRequest () {
      this.openLoadingInDiv()
      this.$apollo
        .mutate({
          mutation: LOGIN_MUTATION,
          variables: {
            email: this.email,
            password: this.password,
            device: this.originalDevice
          }
        })
        .then((response) => {
          localStorage.setItem(
            'userEmailPhone',
            JSON.stringify({
              email: response.data.login.user.email,
              phone: response.data.login.user.phone,
              email_confirmed: response.data.login.user.email_confirmed,
              phone_verified: response.data.login.user.phone_verified
            })
          )
          localStorage.setItem(
            'firebase_user',
            JSON.stringify({
              location:response.data.login.user.locations.length > 0 ? response.data.login.user.locations[0].id : null,
              id:response.data.login.user.id,
              fname: response.data.login.user.fname,
              lname: response.data.login.user.lname,
              role: response.data.login.user.roles,
              avatar: response.data.login.user.avatar ? response.data.login.user.avatar : ''
            })
          )


          if (response.data.login.user.pending == true) {
            this.$vs.loading.close('#div-with-loading > .con-vs-loading')
            this.AccountPendingNotification()
          } else if (response.data.login.user.status == false) {
            this.$vs.loading.close('#div-with-loading > .con-vs-loading')
            this.AccountApprovalNotification()
          } else if (response.data.login.user.roles == '') {
            this.$vs.loading.close('#div-with-loading > .con-vs-loading')
            this.NotAuthorizedNotification()
          } else if (response.data.login.status == 'SUCCESS') {
            localStorage.setItem('session_id', response.data.login.session_id)
            localStorage.removeItem(ROLES_KEY)
            localStorage.setItem(APP_TOKEN, response.data.login.access_token)
            localStorage.setItem(
              ROLES_KEY,
              JSON.stringify(response.data.login.user.roles)
            )
            localStorage.setItem('userId', response.data.login.user.id)
            localStorage.setItem(
              'firebase_token',
              response.data.login.firebase_token
            )
            this.StatusSuccess()
            if (response.data.login.user.avatar !== null) {
              localStorage.setItem(
                'userImage',
                response.data.login.user.avatar
              )
            } else {
              localStorage.removeItem('userImage')
            }
            localStorage.setItem(
              'userName',
              `${response.data.login.user.fname} ${response.data.login.user.lname}`
            )

            this.LastLogin(response.data.login.user.id)

            this.$acl.change(response.data.login.user.roles[0].name)

            this.removeCache()


            if (
              ['user', 'blog'].includes(
                response.data.login.user.roles[0].name
              ) === false
            ) {
              window.location = '/'
            } else if (response.data.login.user.roles[0].name === 'blog') {
              window.location = '/blogs'
            } else if (process.env.VUE_APP_I18N_LOCALE === 'dogs') {
              window.location = '/contact/pets/cameras'
            } else {
              window.location = '/'
            }

            this.$vs.loading.close('#div-with-loading > .con-vs-loading')
          } else if (response.data.login.status == 'PENDING') {
            localStorage.setItem('session_id', response.data.login.session_id)
            this.$vs.loading.close('#div-with-loading > .con-vs-loading')
            this.AccountPendingNotification()
          } else if (response.data.login.status == 'LOGIN_LIMITS_OVER') {
            this.$vs.loading.close('#div-with-loading > .con-vs-loading')
         
            this.LoginLimitNotification('Your logins limit for today has expired!')
          } else if (response.data.login.status == 'NO_STUDENT_ASSOCIATED') {
            this.$vs.loading.close('#div-with-loading > .con-vs-loading')
 
            this.LoginLimitNotification('You don\'t have any student associated with your account!')
          } else if (response.data.login.status == 'NO_CAMERA_ASSOCIATED') {
            this.$vs.loading.close('#div-with-loading > .con-vs-loading') 
            this.LoginLimitNotification('You don’t have access to any camera.  Please contact customer support.')
          } else if (response.data.login.status == 'NO_LOCATION_ASSOCIATED') {
            this.$vs.loading.close('#div-with-loading > .con-vs-loading')
 
            this.LoginLimitNotification('You don’t have access to any camera.  Please contact customer support.')
          }
        })
        .catch((error) => {
          console.log('error-----------', error)
          this.$vs.loading.close('#div-with-loading > .con-vs-loading')
          this.StatusInvalid()
        })
    },

    submitData () {
      if (this.validateForm) {
        this.openLoadingInDiv()
        this.$apollo
          .mutate({
            mutation: CHECK_USER_SESSION,
            variables: {
              email: this.email,
              password: this.password,
              session_id: localStorage.getItem('session_id')
            }
          })
          .then((response) => {
            if (response.data.checkUserSession.status === 'Success') {
              this.$vs.loading.close('#div-with-loading > .con-vs-loading')
              this.sendLoginRequest()
            } else if (response.data.checkUserSession.status === 'Exists') {
              if (response.data.checkUserSession.device) {
                this.prevDevice = JSON.parse(
                  response.data.checkUserSession.device
                )
              }
              this.$vs.loading.close('#div-with-loading > .con-vs-loading')
              this.activePrompt2 = true
              // this.$vs.dialog({
              // color:this.colorAlert,
              // title: `Loggedin into other device`,
              // text: 'You have loggedin into other device, would you like to logout from other device ?',
              // accept:this.sendLoginRequest
              // })
            } else if (response.data.checkUserSession.status === 'Pending') {
              this.AccountPendingNotification()
              this.$vs.loading.close('#div-with-loading > .con-vs-loading')
            } else if (response.data.checkUserSession.status === 'Disabled') {
              this.AccountApprovalNotification()
              this.$vs.loading.close('#div-with-loading > .con-vs-loading')
            } else {
              this.StatusInvalid()
              this.$vs.loading.close('#div-with-loading > .con-vs-loading')
            }
          })
          .catch((error) => {
            console.log(error)
            this.StatusInvalid()
            this.$vs.loading.close('#div-with-loading > .con-vs-loading')
          })
      }
    },

    StatusSuccess () {
      this.$showNotification({
        title: 'User',
        text: 'Logged in successfully!',
        color: 'success',
        position: 'top-right'
      })
    },
    LoginLimitNotification (message) {
      this.$showNotification({
        title: 'Warning',
        text: message,
        color: 'danger',
        position: 'top-right'
      })
    },
    NotAuthorizedNotification () {
      this.$showNotification({
        title: 'Authorization Failed',
        text: 'User Not Authorized!',
        color: 'danger',
        position: 'top-right'
      })
    },
    AccountApprovalNotification () {
      this.$showNotification({
        title: 'Warning',
        text: 'Your account is disabled. Please contact customer support.',
        color: 'danger',
        position: 'top-right'
      })
    },
    AccountPendingNotification () {
      this.$showNotification({
        title: 'Warning',
        text: 'Your account is pending. Please contact customer support.',
        color: 'danger',
        position: 'top-right'
      })
    },
    StatusInvalid () {
      this.$showNotification({
        title: 'Login Failed',
        text: 'Incorrect username/email or password.',
        color: 'danger',
        position: 'top-right'
      })
    },
    removeCache () {
      localStorage.removeItem('old_userEmailPhone')
      localStorage.removeItem('old_userRoles')
      localStorage.removeItem('old_userImage')
      localStorage.removeItem('old_userName')
      localStorage.removeItem('old_app-token')
      localStorage.removeItem('old_userId')
    },
    redirectToKidsVision () {
      this.$router.push('/pages/404-error')
    }
  },

  beforeCreate () {
    this.$apollo
      .query({
        query: CHECK_CENTER_EXIST
      })
      .then(response => {
        if (response.data.checkCenterExist) {
          this.viewPage = response.data.checkCenterExist
        } else {
          this.redirectToKidsVision()
        }
      })
      .catch(error => {
        if (error.graphQLErrors[0] && error.graphQLErrors[0].debugMessage === 'This request is incomplete. Please consult the API documentation or contact support to resolve this issue.') {
          this.redirectToKidsVision()
        }  
        if (error.graphQLErrors[0] && error.graphQLErrors[0].debugMessage === 'You are temporarily blocked. Please try again later.') {
          this.$showNotification({
            title: 'Too Many Requests',
            text: error.graphQLErrors[0].debugMessage,
            position: 'top-center',
            color: 'danger'
          })
        }
      })

    // if (localStorage.getItem('app-token')) {
    // const userRoles = JSON.parse(localStorage.getItem('userRoles'))
    // if (userRoles[0].name != 'user') {
    //   window.location = '/'
    // } else if (process.env.VUE_APP_I18N_LOCALE === 'dogs') {
    //   window.location = '/contact/pets/cameras'
    // } else {
    //   window.location = '/user/students/cameras'
    // }
    // } else {
    // this.$apollo
    //   .query({
    //     query: GET_IMAGE_SETTING
    //   })
    //   .then(response => {
    //     if (response.data.getImagesSetting.login_page_image != null) {
    //       this.setLoginImage = response.data.getImagesSetting.login_page_image
    //     }
    //     if (response.data.getImagesSetting.show_login_img != null) {
    //       this.showLoginImage = response.data.getImagesSetting.show_login_img
    //     }
    //   })
    //   .catch(error => {
    //     console.log(error)
    //   })
    // }
  },
  
  mounted () {
 
    const deviceDetector = new DeviceDetector()
    const device = deviceDetector.parse(navigator.userAgent)

    let originalDevice = {}
    originalDevice.client = `${device.client.name} ${device.client.type}`
    originalDevice.os = `${device.os.name}`
    originalDevice.type = `${device.device.type}`
    originalDevice.device = `${device.device.brand} ${device.device.model}`

    originalDevice = JSON.stringify(originalDevice)

    this.originalDevice = originalDevice
  }
}
</script>

<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook {
      background-color: #1551b1;
    }
    .bg-twitter {
      background-color: #00aaff;
    }
    .bg-google {
      background-color: #4285f4;
    }
    .bg-github {
      background-color: #333;
    }
  }
}
.onfocus:focus {
  opacity: 0.7;
  text-shadow: 2px 2px 2px red;
}
#div-with-loading:focus {
  box-shadow: 0 8px 25px -8px rgba(var(--vs-primary), 1);
}
.onfocus-register:focus {
  background: rgba(var(--vs-primary), 0.08) !important;
}
.onfocus-forgot:focus {
  color: blue;
  text-shadow: 0 0 black;
}
.onfocus-check .vs-checkbox-primary .vs-checkbox:focus {
  border: 3px solid #b4b4b4 !important;
  background: red !important;
}
</style>
<style>
#checkbox_focus {
  visibility: visible;
  height: 20px;
  width: 30px;
  position: absolute;
}
input[type="checkbox"].checkbox_focus:focus + label {
  border: 1px solid black;
}
.no-right-border .vs-inputx {
  border-right: none !important;
}
.bc.vx-input-group .vx-input-group-append{
  display: inline;
  margin-top: 17px;
}
</style>
